import React from 'react';
import { Gift, Sparkles } from 'lucide-react';
export function BonusesSection() {
  const bonuses = [{
    num: '01',
    label: 'Bono #1',
    title: 'El Sistema de 4 Pasos para Detectar Manipuladores',
    desc: 'Guía de acción rápida para identificar perfiles tóxicos en tu entorno y proteger tu integridad emocional. Incluye señales de alerta, scripts de respuesta y un checklist de protección personal.',
    originalPrice: '$8.99',
    img: 'https://i.postimg.cc/cHxxSdDv/4a394b7f-1-min.png'
  }, {
    num: '02',
    label: 'Bono #2',
    title: '7 Frases Poderosas para Persuadir en Segundos',
    desc: 'Estructuras lingüísticas probadas que activan respuestas emocionales profundas. Úsalas en ventas, liderazgo, negociación y conversaciones difíciles para obtener resultados inmediatos.',
    originalPrice: '$7.99',
    img: 'https://i.postimg.cc/4dWJ4jMB/523442c4-1-min.png'
  }, {
    num: '03',
    label: 'Bono #3',
    title: 'Acceso a la Comunidad Exclusiva',
    desc: 'Grupo privado con otros lectores de Código Oscuro donde puedes resolver dudas, compartir experiencias y seguir creciendo con apoyo continuo de la comunidad.',
    originalPrice: '$10.00',
    img: 'https://i.postimg.cc/rszqDQ2c/5e1df0a7-1-min.png'
  }];
  return <section className="py-14 md:py-20 bg-[linear-gradient(160deg,#0c0800_0%,var(--negro)_100%)] border-t border-[rgba(201,151,43,.15)]" data-id="element-73">
      <div className="container" data-id="element-74">
        <div className="text-center max-w-[600px] mx-auto mb-10 md:mb-12" data-id="element-75">
          <div className="section-label justify-center" data-id="element-76">
            <Gift className="w-4 h-4 text-dorado" data-id="element-77" />
            Incluido hoy sin costo extra
          </div>
          <h2 className="font-playfair text-[clamp(1.7rem,3.5vw,2.7rem)] font-bold leading-[1.2] text-blanco text-center" data-id="element-78">
            3 Bonos Exclusivos
            <br data-id="element-79" />
            <em className="text-dorado-claro not-italic italic" data-id="element-80">
              valorados en $26.98
            </em>
          </h2>
          <p className="text-gris-texto mt-3 text-[.91rem]" data-id="element-81">
            Al adquirir Código Oscuro hoy, recibes estos tres recursos
            adicionales — completamente gratis.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-82">
          {bonuses.map((b, i) => <div key={i} className="relative group bg-[rgba(201,151,43,.04)] border border-[rgba(201,151,43,.18)] rounded-xl overflow-hidden transition-all duration-300 hover:border-[rgba(201,151,43,.45)] hover:-translate-y-1 hover:shadow-[0_12px_40px_rgba(201,151,43,.12)]" data-id="element-83">
              {/* Top accent line */}
              <div className="absolute top-0 left-0 right-0 h-[3px] bg-[linear-gradient(90deg,transparent,var(--dorado-claro),var(--dorado),transparent)] opacity-60 group-hover:opacity-100 transition-opacity" data-id="element-84" />

              {/* Bonus number badge */}
              <div className="absolute top-4 left-4 z-10 bg-dorado text-negro text-[10px] font-black tracking-[.12em] uppercase py-1 px-2.5 rounded-md shadow-[0_2px_8px_rgba(201,151,43,.4)]" data-id="element-85">
                {b.label}
              </div>

              {/* Image area */}
              <div className="relative bg-[rgba(201,151,43,.06)] p-6 pt-12 pb-4 flex justify-center" data-id="element-86">
                <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(201,151,43,.08)_0%,transparent_70%)]" data-id="element-87" />
                <img src={b.img} alt={b.label} className="relative z-[1] w-full max-w-[240px] md:max-w-[220px] rounded-md drop-shadow-[0_8px_24px_rgba(0,0,0,.5)] group-hover:scale-[1.03] transition-transform duration-300" data-id="element-88" />
              </div>

              {/* Content */}
              <div className="p-5 pt-4 flex flex-col flex-1" data-id="element-89">
                <h3 className="font-playfair text-[1.05rem] md:text-[1rem] text-blanco mb-2 leading-[1.3]" data-id="element-90">
                  {b.title}
                </h3>
                <p className="text-[.84rem] text-gris-texto leading-[1.65] mb-4 flex-1" data-id="element-91">
                  {b.desc}
                </p>

                {/* Price tag */}
                <div className="bg-[rgba(29,185,84,.08)] border border-[rgba(29,185,84,.25)] rounded-lg p-3 flex items-center justify-between gap-3" data-id="element-92">
                  <div data-id="element-93">
                    <div className="text-[10px] uppercase tracking-[.1em] text-gris-texto mb-0.5" data-id="element-94">
                      Valor original
                    </div>
                    <span className="text-rojo-vivo line-through font-bold text-[1rem]" data-id="element-95">
                      {b.originalPrice}
                    </span>
                  </div>
                  <div className="flex items-center gap-1.5 bg-verde text-white text-[13px] font-black uppercase tracking-[.06em] py-2 px-4 rounded-full shadow-[0_4px_16px_rgba(29,185,84,.35)]" data-id="element-96">
                    <Sparkles className="w-3.5 h-3.5" data-id="element-97" />
                    GRATIS
                  </div>
                </div>
              </div>
            </div>)}
        </div>

        {/* Total value callout */}
        <div className="mt-8 text-center" data-id="element-98">
          <div className="inline-flex items-center gap-3 bg-[rgba(201,151,43,.08)] border border-[rgba(201,151,43,.25)] rounded-full py-3 px-6" data-id="element-99">
            <Gift className="w-5 h-5 text-dorado-claro" data-id="element-100" />
            <span className="text-crema-oscuro text-[.88rem]" data-id="element-101">
              Valor total de los bonos:{' '}
              <span className="text-rojo-vivo line-through font-semibold" data-id="element-102">
                $26.98 USD
              </span>
            </span>
            <span className="text-verde font-bold text-[.95rem]" data-id="element-103">
              → HOY GRATIS
            </span>
          </div>
        </div>
      </div>
    </section>;
}